import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IconButton } from '@/components/elements';
import { laptop, tabletPortrait } from '@/components/utils';

import { LocationTeaser } from '../LocationTeaser';
import { Wrapper } from '../Wrapper';

type IStyledGridProps = {
  $items: number;
};

export const StyledLocationTeaser = styled(LocationTeaser)``;

const handleGrid = (items: number) => {
  switch (items) {
    case 2:
      return `grid-template-columns: repeat(${items}, 1fr);`;
    case 3:
      return `grid-template-columns: repeat(${items}, 1fr);`;
    case 4:
      return 'grid-template-columns: repeat(2, 1fr);';
    case 5:
      return `
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr 0.5fr;
        grid-template-areas:
          "first first first second second second"
          "third third fourth fourth fifth fifth";

        ${StyledLocationTeaser}:first-of-type {
          grid-area: first;
        }

        ${StyledLocationTeaser}:nth-child(2) {
          grid-area: second;
        }

        ${StyledLocationTeaser}:nth-child(3) {
          grid-area: third;
        }

        ${StyledLocationTeaser}:nth-child(4) {
          grid-area: fourth;
        }

        ${StyledLocationTeaser}:last-child {
          grid-area: fifth;
        }
      `;
    case 6:
      return 'grid-template-columns: repeat(3, 1fr);';
  }
};

export const StyledWrapper = styled(Wrapper)`
  padding-bottom: 0;
`;

export const StyledGrid = styled(Wrapper)<IStyledGridProps>`
  display: grid;
  gap: var(--distance-static-l);

  ${({ $items }) => handleGrid($items)};
`;

export const StyledSlider = styled.div`
  position: relative;
  padding-bottom: var(--distance-dynamic-xl);

  @media screen and (${tabletPortrait}) {
    padding-left: var(--distance-static-xxl);
  }

  @media screen and (${laptop}) {
    padding-left: 0;
  }
`;

export const StyledSwiper = styled(Swiper)`
  & > ul {
    display: flex;
    box-sizing: border-box;
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  padding: var(
    --distance-static-3xs
  ); // to show teaser box shadow in overflow context from the slider
  height: auto;
`;

const StyledSwiperButton = styled(IconButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: var(--zindex-m);
`;

export const StyledSwiperButtonPrev = styled(StyledSwiperButton)`
  left: var(--page-spacing-dynamic);
`;

export const StyledSwiperButtonNext = styled(StyledSwiperButton)`
  right: var(--page-spacing-dynamic);
`;
